<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <h4 class="text-center">Administración de Programas</h4>
          <hr class="horizontal dark" />
          <div class="d-flex justify-content-end">
            <a class="btn btn-addiuva-dark" @click="iniciarCrearPrograma()">
              <i class="fas fa-plus"></i> &nbsp; Crear Nuevo Programa
            </a>
          </div>
          <Toast />
          <DataTable :value="programas" stripedRows paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <center class="text-gray">No hay programas que mostrar. </center></template>
            <Column field="nombres" header="ID Plan" sortable ></Column>
            <Column field="email" header="Plan" sortable ></Column>
            <Column field="apellidos" header="Valor Cobertura" sortable ></Column>
            <Column field="nombreRol" header="Límite de Cobertura" sortable ></Column>
            <Column field="activo" header="Activo" sortable >
                <template #body="{ data }">
                    <Tag :value="(data.activo ? 'ACTIVO' : 'INACTIVO')" :severity="getSeverity(data.activo)" rounded/>
                </template>
            </Column>
            <Column field="company" header="Acción" style="width: 5%">
              <template #body="{ data }">
                <SplitButton label="Acciones" icon="fas fa-ellipsis-h" :model="data.items" menuButtonIcon="fas fa-ellipsis-h"  text v-if="data.items.length > 0" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    <!-- Modal Dialogs -->
    <!-- Resetear Contraseña -->
    <Dialog v-model:visible="resetear.visible" modal header="Header" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <template #header>
          <div class="inline-flex align-items-center justify-content-center gap-2">
            <h5 class="text-bold white-space-nowrap text-addiuva-dark">Resetear Contraseña</h5>
          </div>
      </template>
      <div class="row">
        <div class="col-md-12">
          Esta seguro de Resetar la contraseña del usuario <b>{{resetear.nombres}} {{resetear.apellidos}}</b>? <br>
          <small>Se le enviara un correo electrónico a <b>{{resetear.email}}</b> xon su nueva contraseña temporal, una vez inicie sesión se le pedira cambiar su contraseña.</small>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-light" style="margin-right:1rem;" @click="closeModalResetear()">
          <i class="fas fa-times pr-1"></i> Cancelar
        </button>
        <Button class="btn btn-addiuva-dark" type="button" label="Resetear Contraseña" icon="fas fa-unlock-alt pr-1" :loading="loadingButton" @click="resetearPassword" />
      </template>
    </Dialog>
    <!-- Crear/Editar Programa -->
    <Dialog v-model:visible="editar.visible" modal header="Header" :style="{ width: '40%' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <template #header>
        <div class="inline-flex align-items-center justify-content-center gap-2">
          <h5 class="text-bold white-space-nowrap text-addiuva-dark" id="title-edit">{{editar.title.toUpperCase()}}</h5>
        </div>
      </template>
      <div class="row">
        <div class="col-md-8">
          <label for="email">ID Plan <span class="text-danger">*</span></label>
          <InputText id="email" class="form-control" v-model="editar.email"/>
        </div>
        <div class="col-md-4">
          <label for="editar-activo">Activo</label>
          <div class="pt-1">
            <InputSwitch v-model="editar.activo" id="editar-activo"/>
          </div>
        </div>
        <div class="col-md-12">
          <label for="nombres">Nombre Plan <span class="text-danger">*</span></label>
          <InputText id="nombres" class="form-control" v-model="editar.nombres"/>
        </div>
        <div class="col-md-12">
          <label for="apellidos">Valor de Cobertura <span class="text-danger">*</span></label>
          <InputNumber
            v-model="editar.cobertura"
            inputId="percent" class="w-100"
            suffix=" %"
            :minFractionDigits="2"
            :maxFractionDigits="2"
          />
        </div>
        <div class="col-md-12">
          <label for="limite-cobertura">Límite de Cobertura <span class="text-danger">*</span></label>
          <InputNumber
            v-model="editar.limite"

            class="w-100"
            prefix="Bs "
            :minFractionDigits="2"
            :maxFractionDigits="2"
          />
        </div>
      </div>
      <template #footer>
        <button class="btn btn-light" style="margin-right:1rem;" @click="closeModal()">
          <i class="fas fa-times pr-1"></i> Cancelar
        </button>
        <button class="btn btn-addiuva-dark" @click="editarPrograma" v-if="editar.id">
          <i class="fas fa-pen pr-1"></i> Editar
        </button>
        <button class="btn btn-addiuva-dark" @click="crearPrograma" v-if="!editar.id">
          <i class="fas fa-save pr-1"></i> Guardar
        </button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import SplitButton from 'primevue/splitbutton';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import Button from 'primevue/button';
import axios from 'axios';
import authHeader from '../services/auth-header';
// import moment from "moment"
export default {
  name: "admin-programas",
  components: {
    DataTable,
    Column,
    Tag,
    Toast,
    SplitButton,
    Button,
    Dialog,
    InputText,
    InputNumber,
    InputSwitch
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      showProfileDropdown: false,
      programas: [],
      resetear: {
        visible: false,
        id: null,
        nombres: null,
        apellidos: null,
        email: null
      },
      editar: {
        visible: false,
        title: null,
        id: null,
        idPersona: null,
        nombres: null,
        apellidos: null,
        fechaNacimiento: null,
        nroDocumento: null,
        telefono: null,
        email: null,
        idRol: null,
        idAgencia: null,
        activo: null,
      },
      rolOptions: [],
      agenciaOptions: [],
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      loadingButton: false
    };
  },
  methods: {
    listUsers() {
      this.programas = [];
      // Send Data by Axios
      let url = this.API_URL + "/usuarios";
      axios({
        url: url,
        method: 'get',
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let programas = [];
            data.forEach(a => {
              programas.push({
                id: a.id_usuario ?? '',
                idPersona: a.id_persona ?? '',
                nombres: a.persona.nombres ?? '',
                apellidos: a.persona.apellidos ?? '',
                fechaNacimiento: a.persona.fecha_nacimiento ?? '',
                nroDocumento:  a.persona.numero_documento ?? '',
                telefono: a.persona.telefono ?? '',
                email: a.persona.email ?? '',
                idRol: a.id_rol ?? '',
                nombreRol: a.nombre_rol ?? '',
                idAgencia: a.id_agencia ?? '',
                nombreAgencia: a.nombre_agencia ?? '',
                logueado: a.logueado ?? '',
                activo: a.activo ?? '',
              });
            });
            programas.forEach(user => {
              user.items = this.subMenuDefault(user);
            });
            this.programas = programas;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getRoles() {
      this.rolOptions = [];
      // Send Data by Axios
      let url = this.API_URL + "/roles/listar";
      axios({
        url: url,
        method: 'post',
        data: {},
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let roles = [];
            response.data.data.forEach(element => {
              roles.push({ text: element.nombre, value: element.id_rol });
            });
            this.rolOptions = roles
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getAgencias() {
      this.rolOptions = [];
      // Send Data by Axios
      let url = this.API_URL + "/agencias/lista";
      axios({
        url: url,
        method: 'post',
        data: {},
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let agencias = [];
            response.data.data.forEach(element => {
              agencias.push({ text: element.nombre, value: element.id_agencia });
            });
            this.agenciaOptions = agencias
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    subMenuDefault(data) {
      let items = [
        {
          label: 'Editar',
          icon: 'fas fa-pen',
          command: () => {
              this.iniciarEdicion(data)
          }
        },
        {
          label: 'Resetear Contraseña',
          icon: 'fas fa-unlock-alt',
          command: () => {
              this.iniciarResetear(data);
          }
        }
      ];
      return items;
    },
    getSeverity(status) {
      let severity = null;
      if (status == true) severity = "success";
      if (status == false) severity = "danger";
      return severity;
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    // Resetear Contraseña
    iniciarResetear(data) {
        this.resetear.visible = true,
        this.resetear.id = data.id
        this.resetear.nombres = data.nombres
        this.resetear.apellidos = data.apellidos
        this.resetear.email = data.email
    },
    closeModalResetear() {
      this.resetear = {
        visible: false,
        id: null,
        nombres: null,
        apellidos: null,
        email: null
      };
    },
    resetearPassword() {
      if (this.resetear.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "id_usuario": this.resetear.id
      }
      // Send Data by Axios
      let url = this.API_URL + "/usuarios/resetContrasena";
      this.loadingButton = true;
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        this.loadingButton = false;
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Se envío un email al usuario con su nueva contraseña temporal.', life: 3000 });
            this.closeModalResetear();
            this.listUsers();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    // Edicion
    iniciarEdicion(data) {
      this.editar = {
        visible: true,
        title: 'Editar Programa',
        id: data.id,
        idPersona: data.idPersona,
        nombres: data.nombres,
        apellidos: data.apellidos,
        fechaNacimiento: this.formatDate(data.fechaNacimiento),
        nroDocumento: data.nroDocumento,
        telefono: data.telefono,
        email: data.email,
        idRol: data.idRol,
        idAgencia: data.idAgencia,
        activo: data.activo
      };
      this.getRoles();
      this.getAgencias();
    },
    closeModal() {
      this.editar = {
        visible: false,
        title: null,
        id: null,
        idPersona: null,
        nombres: null,
        apellidos: null,
        fechaNacimiento: null,
        nroDocumento: null,
        telefono: null,
        email: null,
        idRol: null,
        idAgencia: null,
        activo: null,
      };
    },
    editarPrograma() {
      if (this.editar.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "persona": {
            "nombres": this.editar.nombres,
            "apellidos": this.editar.apellidos,
            "fecha_nacimiento": this.editar.fechaNacimiento,
            "numero_documento": this.editar.nroDocumento,
            "telefono": this.editar.telefono.toString(),
            "email": this.editar.email,
        },
        "password": 'sample',
        "activo": this.editar.activo,
        "id_rol": this.editar.idRol,
        "id_agencia": this.editar.idAgencia,
      }
      // Send Data by Axios
      let url = this.API_URL + "/usuarios/" + this.editar.id;
      axios({
        url: url,
        method: 'put',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La Edición fue procesada exitosamente', life: 3000 });
            this.closeModal();
            this.listUsers();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    crearPrograma() {
      if (this.editar.id != null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error.', life: 3000 });
        return true;
      }
      let payload = {
        "persona": {
            "nombres": this.editar.nombres,
            "apellidos": this.editar.apellidos,
            "fecha_nacimiento": this.editar.fechaNacimiento,
            "numero_documento": this.editar.nroDocumento,
            "telefono": this.editar.telefono ? this.editar.telefono.toString() : '',
            "email": this.editar.email,
        },
        "password": 'sample',
        "activo": this.editar.activo,
        "id_rol": this.editar.idRol,
        "id_agencia": this.editar.idAgencia,
      }
      // Send Data by Axios
      let url = this.API_URL + "/usuarios";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'El programa fue creado exitosamente', life: 3000 });
            this.closeModal();
            this.listUsers();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    // Restauración
    iniciarCrearPrograma() {
      this.getRoles();
      this.getAgencias();
      this.editar = {
        visible: true,
        title: 'Crear Programa',
        id: null,
        idPersona: null,
        nombres: null,
        apellidos: null,
        fechaNacimiento: null,
        nroDocumento: null,
        telefono: null,
        email: null,
        idRol: null,
        idAgencia: null,
        activo: true,
      }
    },
    formatDate: function (date) {
      let aDate = date.split('/');
      return new Date(aDate[2], parseInt(aDate[1])-1, aDate[0]);
    },
    validateRoute(){
      let menus = this.getProfileMe.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Dashboard'});
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.validateRoute();
    this.listUsers()
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
.vuejs3-datepicker__calendar {
  /* position: relative !important; */
}
</style>